export const DateCustomPeriodTypeFormat = (DateValue: Date) => {
  return (
    (DateValue.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    DateValue.getDate().toString().padStart(2, '0') +
    '-' +
    DateValue.getFullYear()
  );
};
